import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import { apiFetch } from 'framework/api';
import { getMetricUnits } from 'areas/service-boards/widgets/common/dataSources/MetricSettingsApi';
import { MetricConfigurationUnitType } from 'areas/metrics/components/MetricSelector/types';
import { MetricUnitDropDownProps } from 'areas/metrics/components/MetricSelector/components/MetricUnitDropDown/props';

const i = require('core/localization/localization').translator({
	'{0} (default)': { no: '{0} (standard)' },
	'Autoscaling': { no: 'Autoskalering' },
});

export const MetricUnitDropDown = observer((props: MetricUnitDropDownProps) => {
	const { unitType, withCustom, ...others } = props;
	const [units, setUnits] = useState([]);
	const [loaded, setLoaded] = useState(false);
	useEffect(() => {
		const load = async () => {
			if (!unitType) return;

			const response = await apiFetch(getMetricUnits(unitType));

			if (response.success) {
				const units = response.data;
				const defaultIndex = units.findIndex((x) => x.value == unitType);
				if (defaultIndex >= 0) {
					units[defaultIndex].description = i('{0} (default)', units[defaultIndex].description);
				}

				const newUnits = [
					{
						label: i('Autoscaling'),
						value: MetricConfigurationUnitType.Autoscaling,
					},
					withCustom
						? {
								label: i('Custom'),
								value: MetricConfigurationUnitType.Custom,
							}
						: null,
					...units.map((x) => ({ label: x.description, value: x.value })),
				].filter((x) => x);

				setUnits(newUnits);
				setLoaded(true);
			}
		};
		load();
	}, [unitType, withCustom]);

	return <AntSelect disabled={!loaded} options={units} showSearch={false} {...others} />;
});
